import * as React from "react";

import Loading from "common/fragments/Loading";
import HeadingView from "common/views/heading/Heading.view";
import { Query } from "core/api/typedQuery";
import { IPanelProps, Panel} from "core/decorators/Panel";
import Category from "./entity/Category";

// const CategoryQuery = Query.queryOne<Category, any>(Category);

@Panel({id: "forumCategoryInfo", pageParams: true})
class CategoryInfoPanel extends React.Component<IPanelProps<void>> {

	public render() {
		const { pageParams } = this.props;

		if(pageParams.categoryName) {
			return (
				<HeadingView viewKey="category.title">{pageParams.categoryName}</HeadingView>
			);
		}

		return null;

		// why wont this refetch when the id changes???
		/*return (
			<CategoryQuery params={{id: pageParams.categoryId}}>
				{
					({data, loading}) => {

						if(loading) {
							return <Loading />;
						}

						if(!data) {
							return "No Category";
						}

						// push the params seperatly from the link to allow use on the same page as the forum panel
						return (
							<HeadingView viewKey="category.title">{data.name}</HeadingView>
						);
					}
				}
			</CategoryQuery>
		);*/
	}
}



// WEBPACK FOOTER //
// ./src/panels/forum/CategoryInfo.panel.tsx